/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react";
import { useNavigate } from "react-router-dom";
import AppContext from "../Utils/appContext";
import { getPaginatedEstimateAgainProducts } from "../Utils/api-service";
import { extractIdFromGid } from "../Utils/categories-divide";
import ProductLoader from "../Components/Common/ProductLoader";
import ProductBadges from "../Components/ProductBadges";
import ProductDetailOffCanvas from "./ProductDetailOffCanvas";
import { showToast } from "../Utils/toast-service";
import { getCart, getProductCartSummary } from "../Utils/cart-service";

const LIMIT_PRODUCTS = 100;
export default function OrderAgain() {
  const [vendorID] = React.useState(localStorage.getItem("vId"));
  const navigate = useNavigate();
  const { showPrice, cartVersion } = React.useContext(AppContext);
  const [products, setProducts] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [showLoadMore, setShowLoadMore] = React.useState(false);
  const [selectedProductId, setSelectedProductId] = React.useState();
  const [selectedProductTitle, setSelectedProductTitle] = React.useState();
  const [limit] = React.useState(LIMIT_PRODUCTS);
  const [offSet, setOffSet] = React.useState(0);
  const [cartSnapshot, setCartSnapshot] = React.useState(() => getCart());

  React.useEffect(() => {
    setCartSnapshot(getCart());
  }, [cartVersion]);
  React.useEffect(() => {
    if (vendorID) {
      fetchProducts(vendorID, limit, offSet);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorID]);
  const fetchProducts = (vendorID, limit, offSet) => {
    setLoading(true);
    try {
      let res = getPaginatedEstimateAgainProducts(vendorID, limit, offSet);
      res.then((data) => {
        if (data.status === 200) {
          const ps = data?.data?.data?.nodes || [];
          setProducts([...products, ...ps]);
          const checkProduct = [...products, ...ps];
          const counts = data?.data?.count;
          setShowLoadMore(counts > checkProduct?.length);
          setLoading(false);
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAddMore = () => {
    setOffSet(offSet + 1);
    fetchProducts(vendorID, limit, offSet + 1);
  };

  const goToProduct = (id) => {
    const productId = extractIdFromGid(id);
    navigate("/product?productId=" + productId);
  };

  const openProductOffcanvas = (id, title) => {
    const productId = extractIdFromGid(id);
    setSelectedProductId(productId);
    setSelectedProductTitle(title);
  };

  const clearOffCanvas = () => {
    $("#removecart").offcanvas("hide");
    setSelectedProductId();
    if (selectedProductTitle) {
      showToast(`${selectedProductTitle} is added to cart.`);
    }
  };
  return (
    <>
      <section className="cart-section pt-10 top-space">
        {products?.length > 0 &&
          products?.map((product, idx) => {
            if (product?.totalInventory === 0) {
              return null;
            }
            const cartSummary = getProductCartSummary(
              cartSnapshot,
              product?.id,
            );
            return (
              <div key={idx}>
                <div className="cart-box px-15">
                  <a
                    onClick={() => goToProduct(product.id)}
                    className="cart-img postition-relative"
                  >
                    <ProductBadges tags={product?.tags} rotate />

                    <img
                      src={
                        product?.featuredImage?.src ||
                        "assets/images/products/1000.jpg"
                      }
                      alt={product?.featuredImage?.altText || ""}
                      className="img-fluid"
                    />
                  </a>
                  <div className="cart-content">
                    <a onClick={() => goToProduct(product.id)}>
                      <h4>{product?.title}</h4>
                    </a>
                    {cartSummary.inCart && (
                      <h5 className="content-color text-green">
                        In cart · Qty {cartSummary.totalQty}
                      </h5>
                    )}
                    {showPrice && (
                      <div className="price">
                        {product?.variants?.nodes?.length > 1 ? (
                          <h4>
                            ₹{product?.priceRange?.minVariantPrice?.amount}
                            <span> onwards </span>
                            {/* ₹{product?.priceRange?.maxVariantPrice?.amount} */}
                          </h4>
                        ) : (
                          <h4>
                            ₹{product?.priceRange?.minVariantPrice?.amount}
                          </h4>
                        )}
                      </div>
                    )}
                    <div className="cart-option">
                      <button
                        data-bs-toggle="offcanvas"
                        data-bs-target="#removecart"
                        type="button"
                        className={`w-100 btn ${
                          cartSummary.inCart ? "btn-outline" : "btn-solid"
                        }`}
                        onClick={() =>
                          openProductOffcanvas(product.id, product?.title)
                        }
                      >
                        {cartSummary.inCart ? "Add more" : "Add to cart"}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="divider"></div>
              </div>
            );
          })}
      </section>
      {!loading && showLoadMore && (
        <div className="estimate-min-top-space" id="estimate-product-loader">
          <a onClick={() => handleAddMore()} className="btn btn-danger">
            Load More
          </a>
        </div>
      )}
      {loading && <ProductLoader />}
      <section className="service-wrapper px-15 pt-0">
        <div className="row">
          <div className="col-4">
            <div className="service-wrap">
              <div className="icon-box">
                <img
                  src="assets/svg/about/diamond.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <span>Super Quality</span>
            </div>
          </div>
          <div className="col-4">
            <div className="service-wrap">
              <div className="icon-box">
                <img
                  src="assets/svg/24-hours.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <span>24/7 Support</span>
            </div>
          </div>
          <div className="col-4">
            <div className="service-wrap">
              <div className="icon-box">
                <img src="assets/svg/wallet.svg" className="img-fluid" alt="" />
              </div>
              <span>Best Price</span>
            </div>
          </div>
        </div>
      </section>
      <section className="panel-space"></section>

      {/* <!-- remove item canvas start --> */}
      <div
        className="offcanvas offcanvas-bottom h-auto removecart-canvas"
        id="removecart"
      >
        <div className="offcanvas-body small">
          <div className="content">
            <ProductDetailOffCanvas
              estimateAgainProductId={selectedProductId}
              clearOffCanvas={clearOffCanvas}
            />
          </div>
        </div>
      </div>
      {/* <!-- remove item canvas end --> */}
    </>
  );
}
